"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = exports.parseCustomComponentMessage = void 0;
const zod_1 = require("zod");
const emittery_1 = __importDefault(require("emittery"));
const windowIdMessageSchema = zod_1.z.object({
    type: zod_1.z.literal('windowId'),
    data: zod_1.z.object({
        parentWindowId: zod_1.z.string(),
    }),
});
const pageContextSchema = zod_1.z.object({
    product: zod_1.z.string(),
    retailerMoniker: zod_1.z.string(),
    versionName: zod_1.z.string(),
    localeLanguage: zod_1.z.optional(zod_1.z.string()),
    localeCountry: zod_1.z.optional(zod_1.z.string()),
    type: zod_1.z.optional(zod_1.z.string()),
    category: zod_1.z.optional(zod_1.z.string()),
    trackingStatus: zod_1.z.optional(zod_1.z.string()),
    trackingStatusCode: zod_1.z.optional(zod_1.z.string()),
    carrier: zod_1.z.optional(zod_1.z.string()),
    trackingNumbers: zod_1.z.optional(zod_1.z.array(zod_1.z.string())),
    orderNumbers: zod_1.z.optional(zod_1.z.array(zod_1.z.string())),
    destinationZip: zod_1.z.optional(zod_1.z.string()),
    originZip: zod_1.z.optional(zod_1.z.string()),
    originCountry: zod_1.z.optional(zod_1.z.string()),
    destinationCountry: zod_1.z.optional(zod_1.z.string()),
    service: zod_1.z.optional(zod_1.z.string()),
    orderDate: zod_1.z.optional(zod_1.z.string()),
    shipDate: zod_1.z.optional(zod_1.z.string()),
    retailerDcId: zod_1.z.optional(zod_1.z.string()),
    productCategory: zod_1.z.optional(zod_1.z.string()),
    promiseDate: zod_1.z.optional(zod_1.z.string()),
    orderApiEnabled: zod_1.z.optional(zod_1.z.boolean()),
    secured: zod_1.z.optional(zod_1.z.boolean()),
    itemIds: zod_1.z.optional(zod_1.z.array(zod_1.z.string())),
});
const settingsMessageSchema = zod_1.z.object({
    type: zod_1.z.literal('settings'),
    data: zod_1.z.object({
        pageContext: pageContextSchema,
        settings: zod_1.z.record(zod_1.z.union([zod_1.z.string(), zod_1.z.number(), zod_1.z.boolean(), zod_1.z.null()])),
    }),
});
const onHelpPillClickMessageSchema = zod_1.z.object({
    type: zod_1.z.literal('onHelpPillClick'),
});
const messageSchema = zod_1.z.discriminatedUnion('type', [
    windowIdMessageSchema,
    settingsMessageSchema,
    onHelpPillClickMessageSchema,
]);
function parseCustomComponentMessage(value) {
    if (typeof value !== 'object' || value === null) {
        return undefined;
    }
    try {
        return messageSchema.parse(value);
    }
    catch (err) {
        if (err instanceof zod_1.z.ZodError &&
            err.issues.length === 1 &&
            err.issues[0].code === zod_1.z.ZodIssueCode.invalid_union_discriminator) {
            return undefined;
        }
        throw err;
    }
}
exports.parseCustomComponentMessage = parseCustomComponentMessage;
function createClient(config = {}) {
    const { window_ = window } = config;
    const emitter = new emittery_1.default();
    const client = {
        emitter,
        connect() {
            window_.addEventListener('message', (ev) => {
                if (ev.source !== window_.parent)
                    return;
                const data = parseCustomComponentMessage(ev.data);
                if (data) {
                    emitter.emit(data.type, 'data' in data ? data.data : undefined);
                }
            });
        },
        postMessage(message) {
            window_.parent.postMessage(message, '*');
        },
    };
    return client;
}
exports.createClient = createClient;
